<template>
  <div class="employee-editor">
    <header class="topbar">
      <img src="@/assets/logogruas.png" alt="HomePage" class="logo-button" @click="backMainPanel" />
      <div class="topbar-title">
        <div class="kicker">Recursos Humanos</div>
        <h1>Nuevo empleado</h1>
        <p class="subtitle">{{ employee_first_name || "—" }} {{ employee_last_name || "" }} · {{ employee_ident || "Sin ID" }}</p>
        <span class="form-status-badge" :class="{ ok: isFormValid, pending: !isFormValid }">
          {{ isFormValid ? "Listo para guardar" : "Faltan campos obligatorios" }}
        </span>
      </div>
      <div class="topbar-actions">
        <button class="btn ghost" type="button" @click="goBack">Cancelar</button>
        <button class="btn primary" type="button" @click="saveEmployee" :disabled="!isFormValid">
          Guardar
        </button>
      </div>
    </header>

    <div class="tabs-wrap">
      <nav class="tabs">
        <button
          v-for="t in tabs"
          :key="t.key"
          class="tab"
          :class="{ active: activeTab === t.key }"
          @click="activeTab = t.key"
        >
          <span class="tab-label">{{ t.label }}</span>
          <span class="tab-hint" v-if="t.hint">{{ t.hint }}</span>
        </button>
      </nav>

      <div class="tab-panel">
        <section v-if="activeTab === 'employee'">
          <div class="main-data-container">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Datos de empleado</h4>
                  <div class="pill">Laboral</div>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">ID</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el ID" v-model="employee_ident" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Nombre(s)</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el nombre" v-model="employee_first_name" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Primer apellido</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el primer apellido" v-model="employee_last_name" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Segundo apellido</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el segundo apellido" v-model="employee_last_name2" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Posición</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la posición" v-model="employee_position" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Fecha de contratación</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la fecha de contratación" v-model="employee_hiring_date" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Departamento</label>
                      <div class="field-control">
                        <select v-model="employee_department">
                          <option value="">Selecciona un departamento</option>
                          <option value="Remolque A, B">Remolque A, B</option>
                          <option value="Remolque C">Remolque C</option>
                          <option value="Remolque D">Remolque D</option>
                          <option value="Administración">Administración</option>
                          <option value="Ventas">Ventas</option>
                          <option value="Sistemas">Sistemas</option>
                          <option value="Operaciones">Operaciones</option>
                          <option value="Mantenimiento">Mantenimiento</option>
                          <option value="Almacén">Almacén</option>
                          <option value="Montacargas">Montacargas</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Grupo de Asistencia</label>
                      <div class="field-control">
                        <select v-model="attendance_group">
                          <option value="">Selecciona un grupo</option>
                          <option v-for="group in attendanceGroupOptions" :key="group" :value="group">{{ group }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Personal remoto</label>
                      <div class="field-control">
                        <div class="radio-group">
                          <label><input type="radio" v-model="is_remote" :value="true" /> Sí</label>
                          <label><input type="radio" v-model="is_remote" :value="false" /> No</label>
                        </div>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Ubicación</label>
                      <div class="field-control">
                        <select v-model="employee_location">
                          <option value="">Selecciona una ubicación</option>
                          <option value="Villa Mitras">Villa Mitras</option>
                          <option value="Lote Santa Catarina">Lote Santa Catarina</option>
                          <option value="Lote San Rafael">Lote San Rafael</option>
                          <option value="Lote San Roberto">Lote San Roberto</option>
                          <option value="Lote China">Lote China</option>
                          <option value="Saltillo">Saltillo</option>
                          <option value="Enzzo">Enzzo</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Empresa assignada</label>
                      <div class="field-control">
                        <select v-model="employee_assigned_company">
                          <option value="">Selecciona una empresa</option>
                          <option value="Grúas Monterrey, SA de CV">Grúas Monterrey, SA de CV</option>
                          <option value="Metro Grúas, SA de CV">Metro Grúas, SA de CV</option>
                          <option value="Gruás Saltillo, SA de CV">Gruás Saltillo, SA de CV</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="maintenance-side">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Estatus de empleado</h4>
                  <div class="pill">Usuario Django</div>
                </div>
                <div class="container-card-body">
                  <div class="status-grid">
                    <div class="field">
                      <label class="field-label">Usuario asignado</label>
                      <div class="field-control">
                        <input type="text" value="Se asigna al crear usuario" disabled />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Estatus de usuario</label>
                      <div class="field-control">
                        <input type="text" value="N/A en creación" disabled />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Fecha de baja</label>
                      <div class="field-control">
                        <input type="text" placeholder="Ej. 2026-03-12" v-model="employee_deactivation_date" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Motivo de baja</label>
                      <div class="field-control">
                        <input type="text" placeholder="Motivo principal" v-model="employee_deactivation_reason" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Comentarios de baja</label>
                      <div class="field-control">
                        <textarea placeholder="Detalles adicionales" v-model="employee_deactivation_notes"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'personal'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Dirección</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">Calle y número</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la calle del personal" v-model="employee_street" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Colonia</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la colonia" v-model="employee_neighborhood" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Municipio</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el municipio" v-model="employee_municipality" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Estado</label>
                      <div class="field-control">
                        <select v-model="employee_state">
                          <option value="">Selecciona un estado</option>
                          <option v-for="state in mexicoStates" :key="state" :value="state">{{ state }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Código postal</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el código postal" v-model="employee_postcode" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Datos personales</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">Número de celular</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el número de celular" v-model="employee_phone" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Sexo</label>
                      <div class="field-control">
                        <select v-model="employee_sex">
                          <option value="1">Masculino</option>
                          <option value="2">Femenino</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Fecha de nacimiento</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la fecha de nacimiento" v-model="employee_birthdate" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Estado civil</label>
                      <div class="field-control">
                        <select v-model="employee_civil_state">
                          <option value="">Selecciona un estado civil</option>
                          <option value="Soltero">Soltero</option>
                          <option value="Casado">Casado</option>
                          <option value="Viudo">Viudo</option>
                          <option value="Union Libre">Union Libre</option>
                          <option value="Divorciado">Divorciado</option>
                        </select>
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">RFC</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el RFC" v-model="employee_rfc" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">CURP</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el CURP" v-model="employee_curp" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Número del seguro social</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el SSN" v-model="employee_ssn" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Número de licencia</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce la licencia" v-model="employee_license_number" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Tipo de licencia</label>
                      <div class="field-control">
                        <input type="text" placeholder="Introduce el tipo de licencia" v-model="employee_license_type" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Expiración de la licencia</label>
                      <div class="field-control">
                        <input type="date" v-model="employee_license_expiration" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Datos familiares</h4>
                  <button type="button" class="btn ghost mini-action-btn" @click="addFamilyMember">Agregar</button>
                </div>
                <div class="container-card-body">
                  <div v-for="(member, index) in familyMembersList" :key="`family-member-${index}`" class="list-row">
                    <div class="field">
                      <label class="field-label">Nombre</label>
                      <div class="field-control">
                        <input v-model.trim="member.name" type="text" placeholder="Nombre completo" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Fecha de nacimiento</label>
                      <div class="field-control">
                        <input v-model="member.birthdate" type="date" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Parentezco</label>
                      <div class="field-control">
                        <input v-model.trim="member.relationship" type="text" placeholder="Ej. Cónyuge, hijo/a" />
                      </div>
                    </div>
                    <button type="button" class="btn remove-item-btn" @click="removeFamilyMember(index)">Quitar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-else-if="activeTab === 'payroll'">
          <div class="main-data-container single-column">
            <div class="maintenance-main">
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Nómina / Sueldos</h4>
                </div>
                <div class="container-card-body">
                  <div class="form-grid">
                    <div class="field">
                      <label class="field-label">% Comisiones</label>
                      <div class="field-control">
                        <input type="number" step="1" min="0" max="100" placeholder="0 a 100" v-model="employee_commission_percentage" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Sueldo pactado</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="agreed_salary" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Sueldo base IMSS</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="imss_base_salary" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Horas extras</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="extra_hours_value" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Horas extras triples</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="triple_extra_hours_value" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Turnos dobles</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="double_shifts_value" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Turnos triples</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="triple_shifts_value" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Premios semanales</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="weekly_incentive_value" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Complemento fijo</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="fixed_complement" />
                      </div>
                    </div>
                    <div class="field">
                      <label class="field-label">Pago de taxis</label>
                      <div class="field-control">
                        <input type="number" step="0.01" inputmode="decimal" v-model="taxi_allowance" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container-card">
                <div class="section-title maintenance-title-row">
                  <h4>Configuración</h4>
                </div>
                <div class="container-card-body">
                  <div class="payroll-config-grid">
                    <div class="payroll-config-column">
                      <h5>Datos Generales</h5>
                      <div class="field">
                        <label class="field-label">Pagar nómina</label>
                        <div class="field-control">
                          <div class="radio-group">
                            <label><input type="radio" v-model="pay_salary" :value="true" /> Sí</label>
                            <label><input type="radio" v-model="pay_salary" :value="false" /> No</label>
                            <label><input type="radio" v-model="pay_salary" :value="null" /> N/D</label>
                          </div>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Tipo de régimen</label>
                        <div class="field-control">
                          <select v-model="regime_type">
                            <option value="">Selecciona una opción</option>
                            <option v-for="option in regimeTypeOptions" :key="option" :value="option">{{ option }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Cotiza IMSS</label>
                        <div class="field-control">
                          <div class="radio-group">
                            <label><input type="radio" v-model="imss_afiliated" :value="true" /> Sí</label>
                            <label><input type="radio" v-model="imss_afiliated" :value="false" /> No</label>
                            <label><input type="radio" v-model="imss_afiliated" :value="null" /> N/D</label>
                          </div>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Forma de pago</label>
                        <div class="field-control">
                          <select v-model="payment_method">
                            <option value="">Selecciona una opción</option>
                            <option v-for="option in paymentMethodOptions" :key="option" :value="option">{{ option }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Frecuencia</label>
                        <div class="field-control">
                          <select v-model="payment_frequency">
                            <option value="">Selecciona una opción</option>
                            <option v-for="option in paymentFrequencyOptions" :key="option" :value="option">{{ option }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">UMF</label>
                        <div class="field-control">
                          <input type="text" v-model.trim="umf" />
                        </div>
                      </div>
                      <div class="field">
                        <label class="field-label">Omitir en Dispersión</label>
                        <div class="field-control">
                          <div class="radio-group">
                            <label><input type="radio" v-model="dispersion_omit" :value="true" /> Sí</label>
                            <label><input type="radio" v-model="dispersion_omit" :value="false" /> No</label>
                            <label><input type="radio" v-model="dispersion_omit" :value="null" /> N/D</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="payroll-config-column">
                      <h5>Bancos</h5>
                      <div class="bank-layout">
                        <div class="bank-row bank-row--account">
                          <label class="bank-label">Banco 1 y Cuenta</label>
                          <span class="bank-sep">:</span>
                          <select v-model="bank1" class="bank-select">
                            <option value="">Selecciona una opción</option>
                            <option v-for="option in bankOptions" :key="`bank1-${option}`" :value="option">{{ option }}</option>
                          </select>
                          <input type="text" class="bank-input" v-model.trim="bank1_account" />
                        </div>
                        <div class="bank-row">
                          <label class="bank-label">Clabe 1</label>
                          <span class="bank-sep">:</span>
                          <input type="text" class="bank-input bank-input--wide" v-model.trim="bank1_clabe" />
                        </div>
                        <div class="bank-row bank-row--account">
                          <label class="bank-label">Banco 2 y Cuenta</label>
                          <span class="bank-sep">:</span>
                          <select v-model="bank2" class="bank-select">
                            <option value="">Selecciona una opción</option>
                            <option v-for="option in bankOptions" :key="`bank2-${option}`" :value="option">{{ option }}</option>
                          </select>
                          <input type="text" class="bank-input" v-model.trim="bank2_account" />
                        </div>
                        <div class="bank-row">
                          <label class="bank-label">Clabe 2</label>
                          <span class="bank-sep">:</span>
                          <input type="text" class="bank-input bank-input--wide" v-model.trim="bank2_clabe" />
                        </div>
                        <div class="bank-row">
                          <label class="bank-label bank-label--multiline">Num. de Empleado para el Banco</label>
                          <span class="bank-sep">:</span>
                          <input type="number" step="1" min="0" class="bank-input bank-input--short" v-model.number="bank_employee_number" />
                        </div>
                        <div class="bank-row">
                          <label class="bank-label">Bonificar impuestos</label>
                          <span class="bank-sep">:</span>
                          <div class="bank-radio-group">
                            <label><input type="radio" v-model="tax_bonus" :value="true" /> Sí</label>
                            <label><input type="radio" v-model="tax_bonus" :value="false" /> No</label>
                            <label><input type="radio" v-model="tax_bonus" :value="null" /> N/D</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <footer class="savebar">
      <div class="savebar-left">
        <span class="savebar-text">Captura de nuevo empleado</span>
      </div>
      <div class="savebar-actions">
        <button class="btn ghost" type="button" @click="goBack">Cancelar</button>
        <button class="btn primary" type="button" @click="saveEmployee" :disabled="!isFormValid">Guardar</button>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "AddNewEmployee",
  data() {
    return {
      activeTab: "employee",
      tabs: [
        { key: "employee", label: "Datos de Empleado", hint: "Laboral y estatus" },
        { key: "personal", label: "Datos Personales", hint: "Contacto y dirección" },
        { key: "payroll", label: "Nomina / Sueldos", hint: "Percepciones y valores" },
      ],
      mexicoStates: [
        "Aguascalientes",
        "Baja California",
        "Baja California Sur",
        "Campeche",
        "Chiapas",
        "Chihuahua",
        "Ciudad de México",
        "Coahuila",
        "Colima",
        "Durango",
        "Estado de México",
        "Guanajuato",
        "Guerrero",
        "Hidalgo",
        "Jalisco",
        "Michoacán",
        "Morelos",
        "Nayarit",
        "Nuevo León",
        "Oaxaca",
        "Puebla",
        "Querétaro",
        "Quintana Roo",
        "San Luis Potosí",
        "Sinaloa",
        "Sonora",
        "Tabasco",
        "Tamaulipas",
        "Tlaxcala",
        "Veracruz",
        "Yucatán",
        "Zacatecas",
      ],
      employee_ident: "",
      employee_first_name: "",
      employee_last_name: "",
      employee_last_name2: "",
      employee_position: "",
      employee_hiring_date: "",
      employee_department: "",
      attendance_group: "",
      is_remote: false,
      employee_location: "",
      employee_assigned_company: "",
      employee_street: "",
      employee_neighborhood: "",
      employee_municipality: "",
      employee_state: "",
      employee_postcode: "",
      employee_phone: "",
      employee_sex: "",
      employee_birthdate: "",
      employee_civil_state: "",
      employee_rfc: "",
      employee_curp: "",
      employee_ssn: "",
      employee_status: 1,
      employee_license_number: "",
      employee_license_type: "",
      employee_license_expiration: "",
      employee_commission_percentage: "",
      agreed_salary: "",
      imss_base_salary: "",
      extra_hours_value: "",
      triple_extra_hours_value: "",
      double_shifts_value: "",
      triple_shifts_value: "",
      weekly_incentive_value: "",
      fixed_complement: "",
      taxi_allowance: "",
      employee_deactivation_date: "",
      employee_deactivation_reason: "",
      employee_deactivation_notes: "",
      pay_salary: null,
      regime_type: "",
      imss_afiliated: null,
      payment_method: "",
      payment_frequency: "",
      umf: "",
      dispersion_omit: null,
      bank1: "",
      bank1_account: "",
      bank1_clabe: "",
      bank2: "",
      bank2_account: "",
      bank2_clabe: "",
      bank_employee_number: null,
      tax_bonus: null,
      regimeTypeOptions: [
        "Sueldos",
        "Jubilados",
        "Pensionados",
        "Asimilados Miembros Sociedades Cooperativas",
        "Asimilados Integrantes Sociedades Asocia",
        "Asimilados Miembros Consejos",
        "Asimilados Comisionistas",
        "Asimilados Honorarios",
        "Asimilados Acciones",
        "Asimilados Otros",
        "Jubilados o Pensionados",
        "Indemnizacion o Separacion",
        "Otro",
      ],
      paymentMethodOptions: ["Efectivo", "Cheque", "Transferencia", "Ninguno"],
      paymentFrequencyOptions: ["Semanal", "Asimilados", "Ninguno"],
      bankOptions: ["Banregio", "BBVA", "Banamex", "Banorte", "Ban Bajio", "Santander", "HSBC", "Otro"],
      attendanceGroupOptions: [
        "Saltillo",
        "Mantenimiento",
        "Auxilio Vial",
        "Enzzo",
        "Montacargas",
        "Call Center",
        "Radio",
        "Administración",
        "Remolque A/B",
        "Remolque C/D",
      ],
      familyMembersList: [{ name: "", birthdate: "", relationship: "" }],
    };
  },
  mounted() {
    const permissions = this.getPermissions();
    if (!permissions.includes("rrhh.create_employee")) {
      this.$router.push({ name: "MainPanel" });
    }
  },
  methods: {
    getPermissions() {
      try {
        return JSON.parse(localStorage.getItem("userPermissions")) || [];
      } catch (error) {
        return [];
      }
    },
    backMainPanel() {
      window.location.href = "/main-panel";
    },
    goBack() {
      history.back();
    },
    defaultFamilyMember() {
      return { name: "", birthdate: "", relationship: "" };
    },
    sanitizeFamilyMembers(list) {
      const cleaned = (list || [])
        .map((item) => ({
          name: (item?.name || "").trim(),
          birthdate: item?.birthdate || "",
          relationship: (item?.relationship || "").trim(),
        }))
        .filter((item) => item.name || item.birthdate || item.relationship);
      return cleaned.length ? cleaned : null;
    },
    normalizeDecimalValue(value) {
      if (value === null || value === undefined || value === "") return null;
      return value;
    },
    normalizeCommissionValue(value) {
      if (value === null || value === undefined || value === "") return null;
      return value;
    },
    normalizeTextValue(value) {
      if (value === null || value === undefined || value === "") return null;
      return String(value).trim();
    },
    normalizeIntegerValue(value) {
      if (value === null || value === undefined || value === "") return null;
      const parsed = Number(value);
      if (Number.isNaN(parsed)) return null;
      return parsed;
    },
    addFamilyMember() {
      this.familyMembersList.push(this.defaultFamilyMember());
    },
    removeFamilyMember(index) {
      this.familyMembersList.splice(index, 1);
      if (!this.familyMembersList.length) this.familyMembersList.push(this.defaultFamilyMember());
    },
    async saveEmployee() {
      try {
        const permissions = this.getPermissions();
        if (!permissions.includes("rrhh.create_employee")) {
          Swal.fire("Sin acceso", "No tienes permisos para crear personal.", "warning");
          return;
        }
        const apiDirectory = process.env.API_DIRECTORY;
        const employeeData = {
          employee_ident: this.employee_ident,
          employee_first_name: this.employee_first_name,
          employee_last_name: this.employee_last_name,
          employee_last_name2: this.employee_last_name2,
          employee_position: this.employee_position,
          employee_hiring_date: this.employee_hiring_date,
          employee_department: this.employee_department,
          attendance_group: this.normalizeTextValue(this.attendance_group),
          is_remote: !!this.is_remote,
          employee_location: this.employee_location,
          employee_assigned_company: this.employee_assigned_company,
          employee_street: this.employee_street,
          employee_neighborhood: this.employee_neighborhood,
          employee_municipality: this.employee_municipality,
          employee_state: this.employee_state,
          employee_postcode: this.employee_postcode,
          employee_phone: this.employee_phone,
          employee_sex: this.employee_sex,
          employee_birthdate: this.employee_birthdate,
          employee_civil_state: this.employee_civil_state,
          employee_rfc: this.employee_rfc,
          employee_curp: this.employee_curp,
          employee_ssn: this.employee_ssn,
          employee_status: this.employee_status,
          employee_license_number: this.employee_license_number,
          employee_license_type: this.employee_license_type,
          employee_license_expiration: this.employee_license_expiration || null,
          employee_commission_percentage: this.normalizeCommissionValue(this.employee_commission_percentage),
          agreed_salary: this.normalizeDecimalValue(this.agreed_salary),
          imss_base_salary: this.normalizeDecimalValue(this.imss_base_salary),
          extra_hours_value: this.normalizeDecimalValue(this.extra_hours_value),
          triple_extra_hours_value: this.normalizeDecimalValue(this.triple_extra_hours_value),
          double_shifts_value: this.normalizeDecimalValue(this.double_shifts_value),
          triple_shifts_value: this.normalizeDecimalValue(this.triple_shifts_value),
          weekly_incentive_value: this.normalizeDecimalValue(this.weekly_incentive_value),
          fixed_complement: this.normalizeDecimalValue(this.fixed_complement),
          taxi_allowance: this.normalizeDecimalValue(this.taxi_allowance),
          pay_salary: this.pay_salary,
          regime_type: this.normalizeTextValue(this.regime_type),
          imss_afiliated: this.imss_afiliated,
          payment_method: this.normalizeTextValue(this.payment_method),
          payment_frequency: this.normalizeTextValue(this.payment_frequency),
          umf: this.normalizeTextValue(this.umf),
          dispersion_omit: this.dispersion_omit,
          bank1: this.normalizeTextValue(this.bank1),
          bank1_account: this.normalizeTextValue(this.bank1_account),
          bank1_clabe: this.normalizeTextValue(this.bank1_clabe),
          bank2: this.normalizeTextValue(this.bank2),
          bank2_account: this.normalizeTextValue(this.bank2_account),
          bank2_clabe: this.normalizeTextValue(this.bank2_clabe),
          bank_employee_number: this.normalizeIntegerValue(this.bank_employee_number),
          tax_bonus: this.tax_bonus,
          employee_deactivation_date: this.employee_deactivation_date,
          employee_deactivation_reason: this.employee_deactivation_reason,
          employee_deactivation_notes: this.employee_deactivation_notes,
        };
        const payload = { ...employeeData };
        const familyMembers = this.sanitizeFamilyMembers(this.familyMembersList);
        if (familyMembers) {
          payload.employee_family_members = familyMembers;
        }
        await axios.post(`${apiDirectory}/create-employee`, payload, {
          headers: { "Content-Type": "application/json" },
        });
        Swal.fire("Guardado", "Los datos del formulario se han guardado con éxito.", "success").then(() => {
          this.$router.push({ name: "RHPersonal" });
        });
      } catch (error) {
        Swal.fire("Error", "Verifique que los datos que está ingresando son válidos", "error");
      }
    },
  },
  computed: {
    isFormValid() {
      return (
        this.employee_ident !== "" &&
        this.employee_first_name !== "" &&
        this.employee_last_name !== "" &&
        this.employee_last_name2 !== "" &&
        this.employee_position !== "" &&
        this.employee_hiring_date !== "" &&
        this.employee_department !== "" &&
        this.employee_location !== "" &&
        this.employee_assigned_company !== "" &&
        this.employee_street !== "" &&
        this.employee_neighborhood !== "" &&
        this.employee_municipality !== "" &&
        this.employee_postcode !== "" &&
        this.employee_phone !== "" &&
        this.employee_sex !== "" &&
        this.employee_birthdate !== "" &&
        this.employee_civil_state !== "" &&
        this.employee_rfc !== "" &&
        this.employee_curp !== "" &&
        this.employee_ssn !== "" &&
        this.employee_status !== "" &&
        this.employee_license_number !== "" &&
        this.employee_license_type !== "" &&
        this.employee_license_expiration !== ""
      );
    },
  },
};
</script>

<style scoped>
.employee-editor {
  min-height: 100vh;
  background: #e9edf5;
  color: #0f172a;
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  min-height: 64px;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 14px;
  background: #ffc434;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.16);
}

.logo-button {
  height: 46px;
  cursor: pointer;
}

.topbar-title {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.kicker {
  font-size: 12px;
  opacity: 0.75;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.topbar-title h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 900;
}

.subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  opacity: 0.8;
}

.form-status-badge {
  margin-top: 6px;
  width: fit-content;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  border: 1px solid transparent;
}

.form-status-badge.ok {
  background: #dcfce7;
  color: #166534;
  border-color: #86efac;
}

.form-status-badge.pending {
  background: #fef3c7;
  color: #92400e;
  border-color: #fcd34d;
}

.topbar-actions {
  margin-left: auto;
  display: flex;
  gap: 10px;
}

.tabs-wrap {
  max-width: 1280px;
  margin: 10px auto 76px;
  padding: 0 16px;
}

.tabs {
  display: flex;
  gap: 8px;
  overflow: auto;
  padding-bottom: 4px;
  scrollbar-width: thin;
}

.tab {
  border: 1px solid #94a3b8;
  background: #f8fafc;
  border-radius: 10px;
  padding: 8px 10px;
  min-width: 170px;
  text-align: left;
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.tab:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.08);
}

.tab.active {
  border-color: #1d4ed8;
  background: #dbeafe;
  box-shadow: 0 6px 14px rgba(29, 78, 216, 0.22);
}

.tab-label {
  display: block;
  font-weight: 900;
  font-size: 12px;
}

.tab-hint {
  display: block;
  font-size: 10px;
  opacity: 0.82;
  margin-top: 2px;
}

.tab-panel {
  margin-top: 10px;
}

.main-data-container {
  display: grid;
  grid-template-columns: repeat(14, minmax(0, 1fr));
  gap: 10px;
}

.main-data-container.single-column {
  grid-template-columns: 1fr;
}

.maintenance-main {
  grid-column: span 10;
  display: grid;
  gap: 10px;
}

.maintenance-side {
  grid-column: span 4;
  display: grid;
  gap: 10px;
}

.main-data-container.single-column .maintenance-main,
.main-data-container.single-column .maintenance-side {
  grid-column: 1 / -1;
}

.container-card {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 0;
  border-top: none;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.08);
}

.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  border-bottom: 1px solid #cbd5e1;
  background: #dbe3ef;
}

.section-title h4 {
  margin: 0;
  font-size: 13px;
  font-weight: 800;
}

.container-card-body {
  padding: 8px;
}

.pill {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: #c7d2fe;
  color: #1e3a8a;
  font-weight: 900;
  font-size: 11px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.payroll-config-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.payroll-config-column {
  border: 1px solid #cbd5e1;
  padding: 10px;
  background: #fff;
  display: grid;
  gap: 8px;
  align-content: start;
  grid-auto-rows: max-content;
}

.payroll-config-column h5 {
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 900;
  color: #1e293b;
}

.bank-layout {
  display: grid;
  gap: 6px;
}

.bank-row {
  display: grid;
  grid-template-columns: 170px 10px minmax(0, 1fr);
  align-items: center;
  gap: 6px;
}

.bank-row--account {
  grid-template-columns: 170px 10px 110px minmax(0, 1fr);
}

.bank-label {
  font-size: 12px;
  font-weight: 700;
  text-align: right;
}

.bank-label--multiline {
  line-height: 1.05;
}

.bank-sep {
  font-weight: 700;
  text-align: center;
}

.bank-input,
.bank-select {
  width: 100%;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #94a3b8;
  border-radius: 6px;
  background: #fff;
  font-size: 12px;
}

.bank-input--wide {
  max-width: 100%;
}

.bank-input--short {
  max-width: 86px;
}

.bank-radio-group {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-height: 28px;
}

.bank-radio-group label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
}

.bank-radio-group input[type="radio"] {
  width: 16px;
  height: 16px;
}

@media (max-width: 1400px) {
  .form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1120px) {
  .main-data-container {
    grid-template-columns: 1fr;
  }
  .maintenance-main,
  .maintenance-side {
    grid-column: 1 / -1;
  }
}

@media (max-width: 900px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  .payroll-config-grid {
    grid-template-columns: 1fr;
  }
  .bank-row,
  .bank-row--account {
    grid-template-columns: 1fr;
  }
  .bank-label {
    text-align: left;
  }
  .bank-sep {
    display: none;
  }
}

.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-size: 11px;
  font-weight: 900;
  color: #0f172a;
}

.field-control input,
.field-control select,
.field-control textarea {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #94a3b8;
  background: #fff;
  outline: none;
  transition: box-shadow 120ms ease, border-color 120ms ease;
  font-size: 12px;
}

.field-control textarea {
  min-height: 76px;
  resize: vertical;
}

.radio-group {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  min-height: 36px;
  width: 100%;
}

.radio-group label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
}

.radio-group input[type="radio"] {
  width: 16px;
  height: 16px;
}

.field-control input:focus,
.field-control select:focus,
.field-control textarea:focus {
  border-color: #1d4ed8;
  box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.18);
}

.status-grid {
  display: grid;
  gap: 10px;
}

.list-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) auto;
  gap: 10px;
  align-items: end;
  padding: 8px 0;
  border-bottom: 1px solid #dbe3ef;
}

.list-row:last-child {
  border-bottom: none;
}

.mini-action-btn {
  padding: 4px 10px;
  font-size: 11px;
}

.btn {
  border: 1px solid #64748b;
  border-radius: 8px;
  padding: 8px 10px;
  font-weight: 900;
  font-size: 12px;
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 18px rgba(15, 23, 42, 0.10);
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn.primary {
  background: #1d4ed8;
  color: #fff;
  border-color: #1e40af;
}

.btn.ghost {
  background: #e2e8f0;
}

.remove-item-btn {
  padding: 6px 10px;
  font-size: 11px;
  background: #ef4444;
  color: #fff;
  border-color: #dc2626;
}

@media (max-width: 1400px) {
  .list-row {
    grid-template-columns: repeat(2, minmax(0, 1fr)) auto;
  }
}

@media (max-width: 900px) {
  .list-row {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
}

.savebar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 25;
  background: rgba(226, 232, 240, 0.96);
  backdrop-filter: blur(10px);
  border-top: 1px solid #94a3b8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
}

.savebar-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.savebar-text {
  font-size: 12px;
  opacity: 0.9;
  font-weight: 700;
}

.savebar-actions {
  display: flex;
  gap: 10px;
}
</style>